import { render, staticRenderFns } from "./CurForm.vue?vue&type=template&id=7971dee0&scoped=true"
import script from "./CurForm.ts?vue&type=script&lang=ts&external"
export * from "./CurForm.ts?vue&type=script&lang=ts&external"
import style0 from "./CurForm.vue?vue&type=style&index=0&id=7971dee0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7971dee0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7971dee0')) {
      api.createRecord('7971dee0', component.options)
    } else {
      api.reload('7971dee0', component.options)
    }
    module.hot.accept("./CurForm.vue?vue&type=template&id=7971dee0&scoped=true", function () {
      api.rerender('7971dee0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/CUR/components/CurForm/CurForm.vue"
export default component.exports